module.exports = __webpack_public_path__ + "static/media/moodle-1.dba77ce3.png";